"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OLModifyContext = exports.OLModifyProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Collection_1 = __importDefault(require("ol/Collection"));
const condition_1 = require("ol/events/condition");
const Modify_1 = __importDefault(require("ol/interaction/Modify"));
const react_1 = require("react");
const useOLMap_1 = require("../openlayers/useOLMap");
function OLModifyProvider({ children }) {
    const map = useOLMap_1.useOLMap();
    const modifiableFeatures = react_1.useMemo(() => new Collection_1.default(), []);
    const modifyInteraction = react_1.useMemo(() => {
        return new Modify_1.default({ features: modifiableFeatures, deleteCondition: condition_1.shiftKeyOnly });
    }, [modifiableFeatures]);
    react_1.useEffect(() => {
        map.addInteraction(modifyInteraction);
        return () => {
            map.removeInteraction(modifyInteraction);
        };
    }, [map, modifyInteraction]);
    react_1.useEffect(() => {
        const onModifyEnd = (event) => {
            event.features.forEach(feature => feature.dispatchEvent('editend'));
        };
        modifyInteraction.on('modifyend', onModifyEnd);
        return () => {
            modifyInteraction.un('modifyend', onModifyEnd);
        };
    }, [modifyInteraction]);
    react_1.useEffect(() => {
        const onModifyStart = (event) => {
            event.features.forEach(feature => feature.dispatchEvent('editstart'));
        };
        modifyInteraction.on('modifystart', onModifyStart);
        return () => {
            modifyInteraction.un('modifystart', onModifyStart);
        };
    }, [modifyInteraction]);
    const value = react_1.useMemo(() => ({ modifiableFeatures }), [modifiableFeatures]);
    return jsx_runtime_1.jsx(exports.OLModifyContext.Provider, Object.assign({ value: value }, { children: children }), void 0);
}
exports.OLModifyProvider = OLModifyProvider;
exports.OLModifyContext = react_1.createContext({
    modifiableFeatures: new Collection_1.default(),
});
//# sourceMappingURL=OLModifyProvider.js.map